import React from 'react';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import { MdAdd } from 'react-icons/md';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { FiX } from 'react-icons/fi';
import { Col, Row } from '@/components/grid/grid-component';
import Styled from './product-link-style';

const cancelPartStyle = {
  cursor: 'pointer',
};
const deleteCol = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

/**
 * @param {string} name name of the input
 * @name LinkInput
 * @description This component is used to add multiple links to a product.
 * @returns {JSX.Element}
 */
const LinkInput = ({ name, handleMultiSelectChange }) => {
  const { control } = useFormContext();

  const { fields, remove, insert } = useFieldArray({
    control,
    name,
  });

  const handleAddLink = () => {
    insert(fields.length, { link: '' });
    handleMultiSelectChange?.([...fields, { link: '' }]);
  };

  return (
    <>
      <Styled.LinkListWrapper>
        {fields.map((field, index) => (
          <Row key={field.id} margin={0}>
            <Col margin={0} xs={10}>
              <Input
                type="text"
                name={`${name}[${index}].link`}
                disabled={false}
              />
            </Col>
            <Col style={deleteCol} xs={2}>
              <FiX
                style={cancelPartStyle}
                onClick={() => {
                  remove(index);
                  const updatedFields = fields.filter((_, i) => i !== index);
                  handleMultiSelectChange?.(updatedFields);
                }}
              />
            </Col>
          </Row>
        ))}
      </Styled.LinkListWrapper>

      <Styled.LinkAddAction onClick={handleAddLink}>
        <MdAdd /> <Styled.ActionText>Add Link</Styled.ActionText>
      </Styled.LinkAddAction>
    </>
  );
};

LinkInput.defaultProps = {
  handleMultiSelectChange: undefined,
};

LinkInput.propTypes = {
  name: PropTypes.string.isRequired,
  handleMultiSelectChange: PropTypes.func,
};

export default LinkInput;
